// ============================================================================
// 📦 VERSION: 2025.11.28.1130
// 🎮 TRAKtag Bottom Navigation Bar
// ============================================================================
import React from 'react';

const BottomNavBar = ({ 
  activeTab, 
  onTabChange,
  unreadNotifications = 0,
  hidden = false 
}) => {
  
  const tabs = [
    { id: 'home', icon: '🏠', label: 'Home' },
    { id: 'quizzes', icon: '🎯', label: 'Quizzes' },
    { id: 'stats', icon: '📊', label: 'Stats' },
    { id: 'settings', icon: '⚙️', label: 'Settings' }
  ];

  if (hidden) return null;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-[9000] bg-gray-900 border-t border-gray-700 safe-area-bottom">
      <div className="max-w-md mx-auto flex justify-around items-center h-16">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex flex-col items-center justify-center flex-1 h-full transition-all relative ${
              activeTab === tab.id
                ? 'text-yellow-400'
                : 'text-gray-400 hover:text-gray-200'
            }`}
          >
            {/* Active indicator */}
            {activeTab === tab.id && (
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-12 h-1 bg-yellow-400 rounded-b-full" />
            )}
            
            {/* Icon */}
            <span className="text-2xl relative">
              {tab.icon}
              {/* Notification badge for settings */}
              {tab.id === 'settings' && unreadNotifications > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-4 h-4 rounded-full flex items-center justify-center font-bold">
                  {unreadNotifications > 9 ? '9+' : unreadNotifications}
                </span>
              )}
            </span>
            
            {/* Label */}
            <span className={`text-xs mt-1 font-medium ${
              activeTab === tab.id ? 'font-bold' : ''
            }`}>
              {tab.label}
            </span>
          </button>
        ))}
      </div>
      
      {/* Safe area spacer for iOS */}
      <div className="h-safe-area-bottom bg-gray-900" />
    </nav>
  );
};

export default BottomNavBar;
